export var getFormattedPermissions = function (_a) {
    var _b, _c;
    var data = _a.data, scope = _a.scope;
    try {
        var permitted = data.features.permitted;
        return _b = {},
            _b[scope] = permitted,
            _b;
    }
    catch (error) {
        console.error('error in formatting permissions: ', error.message);
        return _c = {}, _c[scope] = {}, _c;
    }
};
